export const isObject = (target) =>
  Object.prototype.toString.call(target) === '[object Object]'
/** 判断是否为数组 */
export const isArray = (arg: unknown) => {
  return Array.isArray
    ? Array.isArray(arg)
    : Object.prototype.toString.call(arg) === '[object Array]'
}

/** 判断是否为字符串 */
export const isString = (str: unknown) => {
  return typeof str === 'string' || str instanceof String
}

/** 判断是否为外链 */
export const isExternal = (path: string) => {
  const reg = /^(https?:|mailto:|tel:)/
  return reg.test(path)
}

/** 判断是否为网址（带协议） */
export const isUrl = (url: string) => {
  const reg =
    /^(((ht|f)tps?):\/\/)?([^!@#$%^&*?.\s-]([^!@#$%^&*?.\s]{0,63}[^!@#$%^&*?.\s])?\.)+[a-z]{2,6}\/?/
  return reg.test(url)
}

/** 判断是否为网址或 IP（带端口） */
export const isUrlPort = (url: string) => {
  const reg = /^((ht|f)tps?:\/\/)?[\w-]+(\.[\w-]+)+:\d{1,5}\/?$/
  return reg.test(url)
}

/** 判断是否为域名（不带协议） */
export const isDomain = (domain: string) => {
  const reg = /^([0-9a-zA-Z-]{1,}\.)+([a-zA-Z]{2,})$/
  return reg.test(domain)
}

/** 判断版本号格式是否为 X.Y.Z */
export const isVersion = (version: string) => {
  const reg = /^\d+(?:\.\d+){2}$/
  return reg.test(version)
}

/** 判断时间格式是否为 24 小时制（HH:mm:ss） */
export const is24H = (time: string) => {
  const reg = /^(?:[01]\d|2[0-3]):[0-5]\d:[0-5]\d$/
  return reg.test(time)
}

/** 判断是否为手机号（1 开头） */
export const isPhoneNumber = (str: string) => {
  const reg = /^(?:(?:\+|00)86)?1\d{10}$/
  return reg.test(str)
}

/** 判断是否为手机号（i18n） */
export const isPhoneNumberI18n = (str: string) => {
  const reg =
    /^([+]?0?\d{2,3}-?|\([+]?0?\d{2,3}\)|\([+]?0?\d{2,3}\))?\d+$|^([+]?0?\d{2,3}-?|\([+]?0?\d{2,3}\)|\([+]?0?\d{2,3}\))?[1-9]\d{4,10}(-\d{1,10})?$/
  return reg.test(str)
}

/** 判断是否为第二代身份证（18 位） */
export const isChineseIdCard = (str: string) => {
  const reg =
    /^[1-9]\d{5}(?:18|19|20)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/
  return reg.test(str)
}

/** 判断是否为 Email（支持中文邮箱） */
export const isEmail = (email: string) => {
  const reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
  return reg.test(email)
}

/** 判断是否为 MAC 地址 */
export const isMAC = (mac: string) => {
  const reg =
    /^(([a-f0-9][0,2,4,6,8,a,c,e]:([a-f0-9]{2}:){4})|([a-f0-9][0,2,4,6,8,a,c,e]-([a-f0-9]{2}-){4}))[a-f0-9]{2}$/i
  return reg.test(mac)
}

/** 判断是否为 IPv4 地址 */
export const isIPv4 = (ip: string) => {
  const reg =
    /^((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.){3}(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])(?::(?:[0-9]|[1-9][0-9]{1,3}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5]))?$/
  return reg.test(ip)
}

/** 判断是否为车牌（兼容新能源车牌） */
export const isLicensePlate = (str: string) => {
  const reg =
    /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-HJ-NP-Z][A-HJ-NP-Z0-9]{4,5}[A-HJ-NP-Z0-9挂学警港澳]$/
  return reg.test(str)
}

/** 判断是否为身份证 */
export const isIdCard = (str: string) => {
  const reg = /^[A-Za-z0-9]+$/
  return reg.test(str)
}

/** 判断是否为字母或數字 */
export const isLettersOrNumbers = (str: string) => {
  const reg = /^[A-Za-z0-9]+$/
  return reg.test(str)
}

/** 判断是否为符号()+-或數字 */
export const isSymbolOrNumbers = (str: string) => {
  // ((?=.*[a-z])(?=.*\d)|(?=[a-z])(?=.*[#@!~%^&*])|(?=.*\d)(?=.*[#@!~%^&*]))[a-z\d#@!~%^&*]{8,16}
  const reg = /^[0-9,(+\-)]+$/
  return reg.test(str)
}

/** 判断是否为正數字 */
export const isZeroOrPositive = (str: string) => {
  // |-[0-9]+\.?[0-9]*
  const reg = /^([0-9]+\.?[0-9]*)$/
  return reg.test(str)
}

/** 密码3选2 */
export const isPassword = (str: string) => {
  const reg = new RegExp(
    // /^(?![A-Za-z]+$)(?![A-Z\d]+$)(?![A-Z\W]+$)(?![a-z\d]+$)(?![a-z\W]+$)(?![\d\W]+$)\S{6,18}$/
    /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{6,18}$/,
  )
  return reg.test(str)
}

/** 用户名 5 - 16 字母数字下划线减号 */
export const isUserName = (str: string) => {
  const reg = /^[a-zA-Z0-9]([-_@.a-zA-Z0-9]{5,18})$/
  return reg.test(str)
}

// 身份证
export const isIdentification = (str: string) => {
  const reg1 = new RegExp(/^[A-Za-z0-9]+$/)
  // const reg2 = new RegExp(
  //   /^((\s?[A-Za-z])|([A-Za-z]{2}))\d{6}(\([0−9A-Za-z]\)|[0-9A-Za-z])$/,
  // ) //香港
  const reg2 = new RegExp(/^([A-Za-z]{1,2})\d{6}\([\dA]\)$/) //香港
  const reg3 = new RegExp(/^[a-zA-Z][0-9]{9}$ | ^[1|5|7][0-9]{6}\([0-9Aa]\)/) //台湾
  const reg4 = new RegExp(/^[1|5|7][0-9]{6}\([0-9Aa]\)/) //澳门
  return reg1.test(str) || reg2.test(str) || reg3.test(str) || reg4.test(str)
}
// 户口本
export const isResidenceBooklet = (str: string) => {
  const reg = new RegExp(/^[a-zA-Z0-9]{3,21}$/)
  return reg.test(str)
}
// 护照
export const isPassport = (str: string) => {
  const reg = new RegExp(/^[a-zA-Z0-9]{5,17}$ | [a-zA-Z0-9]{5,17}$/)
  return reg.test(str)
}
// 军官
export const isOfficer = (str: string) => {
  const reg = new RegExp(/^[\u4E00-\u9FA5]{1,2}(字第)([0-9a-zA-Z]{4,8})(号?)$/)
  return reg.test(str)
}
// 驾驶
export const isSteer = (str: string) => {
  const reg = new RegExp(
    /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}(\d|x|X)$/,
  )
  return reg.test(str)
}
// 港澳居民来往内地通行证
export const isHKPermit = (str: string) => {
  // const reg = new RegExp(/^([a-zA-Z]{2}|[a-zA-Z]{1})([0-9]{10}|[0-9]{8})$/)
  const reg = new RegExp(/^([a-zA-Z]{2}|[a-zA-Z]{1})([0-9]{6,10})$/)
  return reg.test(str)
}
// 台湾通行证
export const isTWPermit = (str: string) => {
  const reg = new RegExp(/^([0-9]{8}|[0-9]{10}|[0-9]{18}|[a-zA-Z0-9]{9,10})$/)
  return reg.test(str)
}

/** 诊所编码 4 - 8 字母开头数字 */
export const isCode = (str: string) => {
  const reg = /^[a-zA-Z]([a-zA-Z0-9]{0,7})$/
  return reg.test(str)
}
/** 诊所编码 字母 */
export const isLetterCode = (str: string) => {
  const reg = /^[A-Za-z][A-Za-z0-9-]+$/
  return reg.test(str)
}
// 是否含有中文
export const hasChineseCharacter = (str: string) => {
  // 先校验输入是否为字符串类型，避免非字符串参数导致报错
  if (typeof str !== 'string') {
    return false
  }
  // 匹配中文字符的正则：[\u4e00-\u9fa5] 覆盖常用的简体中文字符范围
  const chineseReg = /[\u4e00-\u9fa5]/
  return chineseReg.test(str)
}
